define('app/sdc/html/sdc-html',["$log", "$timeout"], function ($log, $timeout) {
	return {
		restrict: "AE",
		controller: {
			bind: {
				"content": "&sdcHtml",
				"onAttach": "&?"
			},
			constructor: ["$watch", "$element", "$self", function ($watch, $element, vm) {
				$watch.controller(vm.content, function (html) {
					if ($element.is("iframe")) {
						var contentHeight;
						var htmlElement = $element.contents().contents().html(html);
						vm.onAttach({
							$elements: {
								html: htmlElement,
								head: htmlElement.children('head'),
								body: htmlElement.children('body')
							}
						});
						$timeout(function () {
							$element.height($element.height());
							// The console.debug statement appers to fix this.
							console.debug("contentHeight", contentHeight = $element.contents().height());
							$element.height(contentHeight);
							htmlElement.css("overflow-x", "auto").contents('body').css("overflow-x", "auto");
						}, 50);
					}
					else {
						$log.warn("Not supported")
					}
				});
			}]
		}
	};
});
